import { LoginUtil } from '@ca/common'

const EMAIL_CENSOR_START = 2
const EMAIL_CENSOR_END = 2
const PHONE_CENSOR_END = 3

export const emailCensored = (email: string): string => {
  if (!LoginUtil.isEmail(email)) return email

  // Split the email into local part and domain part
  const [localPart, domainPart] = email.split('@')

  // Extract the first x letters of the local part
  const visibleLocalPart = localPart.slice(0, EMAIL_CENSOR_START)

  // Find the position of the last dot in the domain part
  const lastDotIndex = domainPart.lastIndexOf('.')

  // Extract the domain ending (e.g., .com)
  const domainEnding = domainPart.slice(lastDotIndex)

  // Extract the last y letters of the domain before the dot
  const visibleDomainPart = domainPart.slice(
    lastDotIndex - EMAIL_CENSOR_END,
    lastDotIndex
  )

  // Combine the parts to form the censored email
  const censoredEmail = `${visibleLocalPart} • • • @ • • • ${visibleDomainPart}${domainEnding}`

  return censoredEmail
}

export const phoneCensored = (phone: string): string => {
  let prefix = ''
  let mainNumber = phone

  // Check if the phone number has a '+' prefix
  if (phone.startsWith('+')) {
    // Find the position of the first non-digit character after the '+'
    const firstNonDigitIndex = phone.slice(1).search(/\D/)
    const prefixEndIndex =
      firstNonDigitIndex === -1 ? phone.length : firstNonDigitIndex + 1
    prefix = phone.slice(0, prefixEndIndex)
    mainNumber = phone.slice(prefixEndIndex)
  }

  // Extract the last X digits of the main number
  const visibleEndPart = mainNumber.slice(-PHONE_CENSOR_END)

  // Replace the rest of the digits with asterisks
  const censoredMainPart = mainNumber
    .slice(0, -PHONE_CENSOR_END)
    .replace(/\d/g, '• ')

  // Combine the parts to form the censored phone number
  const censoredPhoneNumber = `${prefix}${
    prefix ? ' ' : ''
  }${censoredMainPart}${visibleEndPart}`

  return censoredPhoneNumber
}

export const lineBreakToSpace = (text: string | undefined | null) => {
  if (!text) return text
  return text.replace(/[\n\r\u2028\u200B]/g, ' ')
}
